export var AllowedActions = {
    colored: 'colored',
    image: 'image',
    big: 'big',
    slider: 'slider',
    as_cover: 'as_cover',
    projects: 'projects',
    'teacher-block': 'teacher-block',
    link: 'link',
    normal: 'normal',
    normal_image: 'normal_image',
    normal_card: 'normal_card',
    normal_emblem: 'normal_emblem',
    course_lesson: 'course_lesson',
    podcast: 'podcast',
    course_presentation: 'course_presentation',
    products: 'products',
    multiple: 'multiple',
    video: 'video',
    'special-tools': 'special-tools',
    bibliography: 'bibliography',
    image_sources: 'image_sources',
    'super-puper-vote': 'super-puper-vote',
    forms: 'forms',
    'two_pictures': 'two_pictures',
    small: 'small',
    card: 'card',
    audio: 'audio',
    buttonLink: 'buttonLink'
};
//# sourceMappingURL=AllowedActions.js.mapexport var AllowedActions = {
    colored: 'colored',
    image: 'image',
    big: 'big',
    slider: 'slider',
    as_cover: 'as_cover',
    projects: 'projects',
    'teacher-block': 'teacher-block',
    link: 'link',
    normal: 'normal',
    normal_image: 'normal_image',
    normal_card: 'normal_card',
    normal_emblem: 'normal_emblem',
    course_lesson: 'course_lesson',
    podcast: 'podcast',
    course_presentation: 'course_presentation',
    products: 'products',
    multiple: 'multiple',
    video: 'video',
    'special-tools': 'special-tools',
    bibliography: 'bibliography',
    image_sources: 'image_sources',
    'super-puper-vote': 'super-puper-vote',
    forms: 'forms',
    'two_pictures': 'two_pictures',
    small: 'small',
    card: 'card',
    audio: 'audio',
    buttonLink: 'buttonLink'
};
//# sourceMappingURL=AllowedActions.js.map